import { useParams } from "react-router-dom";
import { DataTable } from "../../components/DataTable";
import { useIntl } from "../../lib/i18n";
import { useFetch } from "../../lib/useFetch";

type Row = {
  id: string;
  direction: string;
  providerMessageId?: string | null;
  triageEnvelope?: unknown;
  receivedAt: string;
};

export default function SmsThreadPage() {
  const { threadId = "" } = useParams();
  const { t } = useIntl();
  const { data, loading, error } = useFetch<{ messages: Row[] }>(
    `/api/v1/tenant/sms/threads/${threadId}`,
  );
  return (
    <div>
      <h1 className="text-2xl font-semibold text-brand-900">
        {t("sms.thread.title").replace("{phone}", "")}
      </h1>
      <DataTable
        rows={data?.messages ?? null}
        loading={loading}
        error={error}
        empty={t("sms.thread.empty")}
        columns={[
          {
            header: "Direction",
            render: (r) =>
              r.direction === "INBOUND"
                ? t("sms.thread.direction.inbound")
                : t("sms.thread.direction.outbound"),
          },
          {
            header: "Received",
            render: (r) => new Date(r.receivedAt).toLocaleString(),
          },
          {
            header: "Triage",
            render: (r) => (r.triageEnvelope ? JSON.stringify(r.triageEnvelope) : "—"),
          },
        ]}
      />
    </div>
  );
}
